import { render } from "./SelectTemplatePopupField.vue?vue&type=template&id=16702a2d&scoped=true"
import script from "./SelectTemplatePopupField.vue?vue&type=script&lang=js"
export * from "./SelectTemplatePopupField.vue?vue&type=script&lang=js"

import "./SelectTemplatePopupField.vue?vue&type=style&index=0&id=16702a2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16702a2d"]])

export default __exports__